import React from 'react';
import './Valores.css';
import Valor from '../../assets/imgs/Preco.png';
import Pagamento from '../../assets/imgs/Pagamentos-1.png';
import Warning from '../../assets/imgs/warning.svg';
function Valores() {
  return (
    <div className='valores-container'>
      <h2>O investimento para ter acesso a todo o material acima é (por enquanto):</h2>
      <div className='valores-content'>
        <h3>Plataforma Insigne de Pesquisa</h3>

        <div className='valores-itens'>
          <p>✅ Livro digital “Pesquisa Científica: Aspectos Práticos”</p>
          <p>✅ Aulas explicativas</p>
          <p>✅ Modelos prontos de trabalhos acadêmicos</p>
          <p>✅ Acesso vitalício à Comunidade Insigne de Pesquisa</p>
          <p>✅ Acesso ao chat da Plataforma para esclarecer dúvidas</p>
          <p>✅ E-books de diversas áreas do conhecimento com 500 temas</p>
          <p>✅ Obras das edições anteriores do Congresso Brasileiro de Direito Aplicado (+150 trabalhos)</p>
          <p>✅ 6 meses de acesso à Plataforma Insigne de Pesquisa</p>
        </div>

        <div className='valor-container'>
          <p className='highlight-1'>Por apenas 6<span>x</span> de:</p>
          <p className='highlight-2'>R$18,45</p>
          <p className='highlight-3'>ou R$100 à vista</p>
          <a href='https://pay.kiwify.com.br/gUgENlX' target='_blank' rel='noreferrer' className='main-btn alt'>QUERO TER ACESSO AGORA!</a>

          <img alt='insigne' src={Pagamento}></img>
        </div>
      </div>
      <p className='aviso-purple'>
        <img alt='insigne' src={Warning}></img>
        Este preço aumentará em breve, visto que o produto está em período de lançamento, portanto, o melhor momento para ter acesso é agora.</p>
    </div>
  );
}

export default Valores;
